import { Link as LinkMui } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import { LinkProps } from './types'

import type { MouseEvent } from 'react'

export const Link = ({ newTab, to, ...muiNavLinkProps }: LinkProps): React.JSX.Element => (
  <LinkMui
    {...muiNavLinkProps}
    component={RouterLink}
    onClick={(event: MouseEvent<HTMLAnchorElement>): void => event.stopPropagation()}
    rel={newTab ? 'noopener noreferrer' : undefined}
    relative='path'
    sx={{
      display: 'inline-flex',
      ...muiNavLinkProps.sx,
    }}
    target={newTab ? '_blank' : undefined}
    to={to}
  />
)
